import React from 'react';
import { Truck, PackageCheck, CheckCircle, MapPinned } from 'lucide-react';
import { Tabs, TabItem } from '@components/Tabs';
import { usePermissions } from '@hooks/usePermissions';
import { ShippingReportView } from './ShippingReportView';
import { PendingDeliveryReportView } from './PendingDeliveryReportView';
import { DeliveredOrdersReportView } from './DeliveredOrdersReportView';
import { FleetRoutesReportView } from '@pages/fleetTracking/FleetRoutesReportView';

/**
 * Página de Relatórios → Transporte com abas:
 *  - 1ª aba: "Pedidos Pendentes de Entrega" (acessível a todos os perfis).
 *  - 2ª aba: "Pedidos Entregues" (restrito a reports.shipping_delivered).
 *  - 3ª aba: "Transporte" (relatório de custos de frete, restrito a reports.shipping).
 *  - 4ª aba: "Rotas do dia (GPS)" (paradas e desvios das rotas, só admin: fleet_tracking.read).
 */
export const ShippingReportsPage: React.FC = () => {
  const { checkPermission } = usePermissions();
  const canViewShipping = checkPermission('reports.shipping').hasPermission;
  const canViewDelivered = checkPermission('reports.shipping_delivered').hasPermission;
  const canViewFleet = checkPermission('fleet_tracking.read').hasPermission;

  const tabs: TabItem[] = [
    {
      id: 'pending-delivery',
      label: 'Pedidos Pendentes de Entrega',
      icon: <PackageCheck size={16} />,
      content: <PendingDeliveryReportView />,
    },
  ];

  if (canViewDelivered) {
    tabs.push({
      id: 'delivered',
      label: 'Pedidos Entregues',
      icon: <CheckCircle size={16} />,
      content: <DeliveredOrdersReportView />,
    });
  }

  if (canViewShipping) {
    tabs.push({
      id: 'shipping',
      label: 'Transporte',
      icon: <Truck size={16} />,
      content: <ShippingReportView />,
    });
  }

  if (canViewFleet) {
    tabs.push({
      id: 'fleet-routes',
      label: 'Rotas do dia (GPS)',
      icon: <MapPinned size={16} />,
      content: <FleetRoutesReportView />,
    });
  }

  return <Tabs tabs={tabs} defaultTab="pending-delivery" />;
};

export default ShippingReportsPage;
